import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShoppingCart, PlusCircle, UserCog, Settings, LogOut, ChevronRight } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
export function CustomerSidebar({
  isMobile,
  closeMobileMenu
}: {
  isMobile?: boolean;
  closeMobileMenu?: () => void;
}) {
  const location = useLocation();
  const {
    logout
  } = useAuth();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const handleClick = () => {
    if (isMobile && closeMobileMenu) {
      closeMobileMenu();
    }
  };
  const navItems = [{
    name: 'Dashboard',
    path: '/customer/dashboard',
    icon: <LayoutDashboard size={20} data-id="element-155" />
  }, {
    name: 'My Orders',
    path: '/customer/orders',
    icon: <ShoppingCart size={20} data-id="element-156" />
  }, {
    name: 'Request Service',
    path: '/customer/request-service',
    icon: <PlusCircle size={20} data-id="element-157" />
  }, {
    name: 'Profile',
    path: '/customer/profile',
    icon: <UserCog size={20} data-id="element-158" />
  }, {
    name: 'Settings',
    path: '/customer/settings',
    icon: <Settings size={20} data-id="element-159" />
  }];
  return <div className={`h-full flex flex-col bg-white border-r border-gray-200 ${isMobile ? 'w-full' : 'w-64'}`} data-id="element-160">
      <div className="p-4 border-b border-gray-200" data-id="element-161">
        <Link to="/" className="flex items-center" data-id="element-162">
          <span className="text-xl font-bold text-primary" data-id="element-163">Smart Homebox</span>
        </Link>
        <div className="mt-2 text-sm text-gray-500" data-id="element-164">Customer Portal</div>
      </div>
      <nav className="flex-1 pt-4 pb-4 overflow-y-auto" data-id="element-165">
        <ul className="space-y-1 px-2" data-id="element-166">
          {navItems.map(item => <li key={item.name} data-id="element-167">
              <Link to={item.path} onClick={handleClick} className={`flex items-center px-4 py-3 text-sm rounded-md group transition-colors ${isActive(item.path) ? 'bg-primary/10 text-primary font-medium' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-168">
                <span className="mr-3" data-id="element-169">{item.icon}</span>
                {item.name}
                <ChevronRight size={16} className={`ml-auto opacity-0 group-hover:opacity-100 transition-opacity ${isActive(item.path) ? 'opacity-100' : ''}`} data-id="element-170" />
              </Link>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-171">
        <button onClick={logout} className="flex items-center w-full px-4 py-3 text-sm text-red-600 rounded-md hover:bg-red-50" data-id="element-172">
          <LogOut size={20} className="mr-3" data-id="element-173" />
          Logout
        </button>
      </div>
    </div>;
}